import type { FC } from 'react';

import {
  StyledIconWrapper,
  StyledClapper,
  StyledBell,
} from './ringing-bell.styled';

type RingingBellProps = {
  className?: string;
};

export const RingingBell: FC<RingingBellProps> = ({ className }) => (
  <StyledIconWrapper className={className}>
    <StyledClapper />
    <StyledBell />
  </StyledIconWrapper>
);
